module.exports = __webpack_public_path__ + "img/intelligent.a357f42c.png";